import { ItemDto } from "src/dtos/item/itemDto";


export interface MST1011_R01Dto extends ItemDto{ 
}

export const defaultMST1011_R01Dto: MST1011_R01Dto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	itemCd: '',
	itemNm: '',
	modelNo: '',
	itemSpec: '',
	itemUnit: '',
	brandCd: '',
	itemGroup: '',
	itemAccount: '',
	stockQty: 0,
	itemCost: 0,
	workCost: 0,
	stockAmount: 0,
	locationCd: '',
	locationNm: '',
	locationCd2: '',
	purQty: 0,
	packQty: 0,
	salQty: 0,
	itemImage: '',
	itemImage2: '',
	customCd: '',
	customNm: '',
	customItemcd: '',
	equipmentCd: '',
	equipmentNm: '',
	prodStockType: 'I',
	inspectYn: 'Y',
	remark: '',

	inserted: false,
	isModified: false
}